import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { DragulaService } from 'ng2-dragula/ng2-dragula';

import { FileUploader, FileItem } from 'ng2-file-upload';

import * as _ from 'lodash';

var romannumerals = require('roman-numerals');

import { environment } from './../../../../environments/environment';

import { AppComponent } from './../../../app.component';

import { BookService } from './../../../services/book.service';
import { SharedService } from './../../../services/shared.service';
import { Book } from '../../../models/Book';
import { Collana } from '../../../models/Collana';
import { Catalogazione } from '../../../models/Catalogazione';
import { Contributor } from '../../../models/Contributor';
import { Argomento } from '../../../models/Argomento';
import { Bisac } from '../../../models/Bisac';
import { Cce } from '../../../models/Cce';
import { Dewey } from '../../../models/Dewey';
import { Onix } from '../../../models/Onix';
import { ProductRelationship } from '../../../models/ProductRelationship';
import { Lingua } from '../../../models/Lingua';
import { ServizioStampa } from '../../../models/ServizioStampa';
import { Editore } from '../../../models/Editore';


import { AllValidationErrors, getFormValidationErrors } from '../../../helpers/get-form-validation-errors'


@Component({
  selector: 'app-book-form',
  templateUrl: './book-form.component.html',
  styleUrls: ['./book-form.component.css'],
  viewProviders: [DragulaService],
  providers: [BookService]
})
export class BookFormComponent implements OnInit {
  wmodel: Book;
  updateMode: boolean;
  publisher: string;
  ean13Validating: boolean;
  allErrors = [];
  mostracampideprecati: boolean = false;
  mongoBook: any;
  book4mongo: any;
  dirty: boolean;
  loading: boolean;

  fcarpettaxls: string;
  uploadingCarpetta: boolean;
  importFromCarpettaShown: boolean;

  uploadingGoogleSheet: boolean;

  onixSelected = {}
  onixCollector = [];
  coverpath: string;

  @ViewChild("fileInput") fileInput;

  private _form: FormGroup;
  @ViewChild('f') set form(ff: FormGroup) {
    if (ff != null && this._form == null) {
      this._form = ff;
      ff.valueChanges.subscribe(o => {
        this.checkErrors(ff);
      })
    }
  }

  public uploader: FileUploader = new FileUploader({ url: environment.server.url + '/book/upload-cover' });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dragula: DragulaService,
    public bookService: BookService,
    public parent: AppComponent) {
    this.publisher = environment.publisher;

    this.dragula.setOptions('bag-contributors', {});

    this.dragula.drop.subscribe((value) => {
      // console.log(value);
      this._crtlAutori(this.wmodel.contributor);
    })
  }

  book4mongopreview() {
    this.book4mongo = this.bookService.toMongo(this.wmodel)
  }

  addNewBook() {
    this.router.navigate(['/book']);
  }

  go2search() {
    this.router.navigate(['/book/search']);
  }

  gotoSito(_ean13: string) {
    window.open(environment.urlPortale + '/control/dettagliolibro?ean13=' + _ean13, "_blank");
  }

  servizioStampa(_ean13) {
    this.router.navigate(['/servizio-stampa/' + _ean13]);
  }

  recensioni(_ean13) {
    this.router.navigate(['/recensioni/' + _ean13]);
  }

  extra(_ean13) {
    this.router.navigate(['/extra/' + _ean13]);
  }

  _prezzo() {
    // console.log(this.wmodel.prezzo)
    return 'EUR ' + ((!this.wmodel || !this.wmodel.prezzo || isNaN(this.wmodel.prezzo)) ? '0,00' : this.wmodel.prezzo.toFixed(2).replace('.', ','));
  }

  _descrizione() {
    return this.wmodel && this.wmodel.descrizione ? this.bookService.html2txt(this.wmodel.descrizione) : '';
  }

  _lingue() {
    let langs = '';
    if (this.wmodel.lingue) {
      this.wmodel.lingue.forEach(lang => {
        if (lang && lang.lingua && lang.tipologia) {
          let aaa = this.onixCollector.find(o => o.list == '74' && o.value == lang.lingua.value)
          if (aaa) {
            langs += (langs ? ', ' : '') + aaa.etichetta;
          }
          // langs += (langs ? ', ' : '') + lang.lingua.etichetta + ' (' + lang.tipologia.etichetta + ')';
        }
      })
    }
    return langs;
  }

  _argomenti() {
    let args = '';
    if (this.wmodel.argomenti) {
      this.wmodel.argomenti.forEach(a => {
        if (a && a.hasOwnProperty('descrizione')) {
          args += (args ? ', ' : '') + a.descrizione;
          // console.log(a, a.hasOwnProperty('descrizione'), args)
        }
      })
    }
    return args;
  }

  _bisac() {
    let bisacs = '';
    if (this.wmodel.bisac) {
      this.wmodel.bisac.forEach(b => {
        if (b && b.hasOwnProperty('codice')) {
          bisacs += (bisacs ? ', ' : '') + b.codice;
          // console.log(b, b.hasOwnProperty('descrizione'), bisacs)
        }
      })
    }
    return bisacs;
  }

  _cce() {
    let cces = '';
    if (this.wmodel.cce) {
      this.wmodel.cce.forEach(c => {
        if (c && c.hasOwnProperty('codice')) {
          cces += (cces ? ', ' : '') + c.codice;
        }
      })
    }
    return cces;
  }

  _stagionalita() {
    let wstagionalita = '';
    if (this.wmodel.stagionalita) {
      this.wmodel.stagionalita.forEach(s => {
        if (s && s.hasOwnProperty('etichetta')) {
          wstagionalita += (wstagionalita ? ', ' : '') + s.etichetta;
        }
      })
    }
    return wstagionalita;
  }

  _destinatari() {
    let wdestinatari = '';
    if (this.wmodel.destinatari) {
      this.wmodel.destinatari.forEach(d => {
        if (d && d.hasOwnProperty('etichetta')) {
          wdestinatari += (wdestinatari ? ', ' : '') + d.etichetta;
        }
      })
    }
    return wdestinatari;
  }

  onOnixChange(onix: Onix) {
    // console.log('onOnixChange', onix)
    if (onix) {
      this.onixSelected[onix.list] = onix;
      if (!this.onixCollector.find(o => o.list == onix.list && o.value == onix.value)) {
        this.onixCollector.push(onix);
      }
    }
  }

  onFormatoChange(e) {
    let _ebook = this.wmodel.tipoProdotto && this.wmodel.tipoProdotto.value == 'ED';
    this.wmodel.formato = !_ebook ?
      (this.wmodel.larghezza ? this.wmodel.larghezza : '?') + 'x' +
      (this.wmodel.altezza ? this.wmodel.altezza : '?') + 'x' +
      (this.wmodel.spessore ? this.wmodel.spessore : '?') : '';
  }

  toArabic(s: string) {
    try {
      if (s) {
        s = romannumerals.toArabic(s.toString())
      }
    }
    catch (e) {
      s = '?'
    }
    return s;
  }

  onTitoloChange(e) {
    let wt = '';
    // console.log(e)

    if (this.wmodel.titolo) {
      wt += this.wmodel.titolo + '. ';
    }

    if (this.wmodel.sottotitolo) {
      wt += this.wmodel.sottotitolo + ' ';
    }

    if (this.wmodel.sottotitolo2) {
      wt += this.wmodel.sottotitolo2 + ' ';
    }

    if (this.wmodel.prefisso) {
      wt += ' (' + this.wmodel.prefisso + ')';
    }

    this.wmodel.titolobreve = wt;
    this.wmodel.titoloEDB = wt;
  }

  _crtlAutori(cc) {
    this.wmodel.autoriabbreviato = '';
    this.wmodel.autoriabbreviatoedb = '';
    this.wmodel.autoriportale = '';
    let wruolo = {
      'A01': 'aut.',
      'A02': 'Con',
      'A07': 'artista',
      'A12': 'ill.',
      'A15': 'pref.',
      'A19': 'postfaz.',
      'A21': 'comm.',
      'A24': 'intr.',
      'A40': 'pres.',
      'A41': 'cur.',
      'B01': 'cur.',
      'B02': 'rev.',
      'B05': 'adattam.',
      'B06': 'trad.',
      'B10': 'cur. e trad.',
      'B16': 'dir.',
      'E04': 'comm.'
    }
    if (cc) {
      cc.forEach(c => {
        if (c && c.codice && c.ruolo) {
          this.wmodel.autoriabbreviato +=
            (this.wmodel.autoriabbreviato ? '; ' : '') +
            (c.cognome ? (c.cognome + (c.nome ? ', ' + c.nome : '')) : c.nome) +
            (wruolo[c.ruolo.value] ? ' (' + wruolo[c.ruolo.value] + ')' : '');

          if (c.boh) {
            this.wmodel.autoriabbreviatoedb +=
              (this.wmodel.autoriabbreviatoedb ? '; ' : '') +
              (c.cognome ? (c.cognome + (c.nome ? ' ' + c.nome : '')) : c.nome) +
              (wruolo[c.ruolo.value] ? ' (' + wruolo[c.ruolo.value] + ')' : '');
            this.wmodel.autoriportale +=
              (this.wmodel.autoriportale ? '; ' : '') +
              (c.nome ? (c.nome + (c.cognome ? ' ' + c.cognome : '')) : c.cognome) +
              (wruolo[c.ruolo.value] ? ' (' + wruolo[c.ruolo.value] + ')' : '');
          }
        }

      })
    }
  }

  onAutoriChange(e, cc) {
    // console.log('onAutoriChange', e, cc)
    this._crtlAutori(cc);
  }

  onEan13Change(e) {
    // console.log('onEan13Change', e, this.updateMode, this.bookService.checkEan(e));
    if (!this.updateMode && this.bookService.checkEan(e)) {
      this.ean13Validating = true;
      setTimeout(() => {
        this.bookService.getBook(e).subscribe((res) => {
          if (res.success && res.book) {
            this.parent.operSnackBar(true, 'EAN-13 esistente');
            this._init();
            this.router.navigate(['/book/' + e]);
            // this.mongoBook = res.book;
            // this.wmodel = this.bookService.fromMongo(this.mongoBook);
            // this.updateMode = true;
            // this.coverpath = this.bookService.getBookCoverPath(e);
          } else {
            // this.coverpath = this.bookService.getBookCoverPath(e);
          }
          this.ean13Validating = false;
          // console.log(res);
        })
      }, 1000);
    }
  }

  persist() {
    if (this._form.valid) {
      this.loading = true;
      this.parent.addToast('', 'salvataggio in corso...', ((wid) => {
        setTimeout(() => {
          this.bookService.persist(this.bookService.toMongo(this.wmodel)).subscribe((res) => {
            console.log(res)
            if (res.success && res.result) {
              this.wmodel = this.bookService.fromMongo(res.result.value);
              this.callSitoEndpoint(this.wmodel.ean13);
            }
            this.parent.clearToast(wid);
            this.loading = false;
            this.parent.operSnackBar(res.success, res.success ? 'salvataggio completato' : res.err)
          })
        }, 1000);
      }))
    }
  }

  getBookFromEdigita(ean13: string) {
    console.log('======== getBookFromEdigita =========')
    this.loading = true;
    this.parent.addToast('', 'importazione e-book in corso...', ((wid) => {
      setTimeout(() => {
        this.bookService.getBookFromEdigita(ean13).subscribe((res) => {
          console.log(res)
          if (res.success) {
            if (res.bookCartaceo) {

              let wbook = this.bookService.fromMongo(res.bookCartaceo);
              let ebook = new Book(res.book);

              wbook.ean13 = ebook.ean13;
              wbook.relatedProducts = ebook.relatedProducts;
              wbook.prezzo = ebook.prezzo;
              wbook.tax = ebook.tax;
              wbook.numinconfezione = ebook.numinconfezione;
              wbook.numedizione = ebook.numedizione;
              wbook.dtpubblicazione = ebook.dtpubblicazione;
              wbook.tipoProdotto = ebook.tipoProdotto;
              wbook.tipoProdottoDettaglio = ebook.tipoProdottoDettaglio;
              wbook.confezione = ebook.confezione;
              wbook.distributoreDigitale = ebook.distributoreDigitale;
              wbook.protezione = ebook.protezione;
              wbook.tipoContenuto1 = ebook.tipoContenuto1;

              wbook.bisac = _.cloneDeep(ebook.bisac);
              // console.log( ebook.bisac)
              // console.log( wbook.bisac)
              wbook.cce = ebook.cce;

              this.wmodel = _.cloneDeep(wbook);
              // console.log( this.wmodel )
            } else {
              this.wmodel = new Book(res.book);
            }

            this.coverpath = this.bookService.getBookCoverPath(ean13);
          }
          // console.log(res)
          this.parent.clearToast(wid);
          this.loading = false;
          this.parent.operSnackBar(res.success, res.success ? 'importazione completata' : res.err)
        })
      }, 1000);
    }))
  }

  getPdfFromEdigita(ean13: string) {
    this.loading = true;
    this.parent.addToast('', 'importazione PDF in corso...', ((wid) => {
      setTimeout(() => {
        this.bookService.getPdfFromEdigita(ean13).subscribe((res) => {
          if (res.success) {
            if (res.bookCartaceo) {
              // console.log(res)
              let wbook = this.bookService.fromMongo(res.bookCartaceo);
              let ebook = new Book(res.book);

              wbook.ean13 = ebook.ean13;
              wbook.relatedProducts = ebook.relatedProducts;
              wbook.prezzo = ebook.prezzo;
              wbook.tax = ebook.tax;
              wbook.numinconfezione = ebook.numinconfezione;
              wbook.numedizione = ebook.numedizione;
              wbook.dtpubblicazione = ebook.dtpubblicazione;
              wbook.tipoProdotto = ebook.tipoProdotto;
              wbook.tipoProdottoDettaglio = ebook.tipoProdottoDettaglio;
              wbook.confezione = ebook.confezione;
              wbook.distributoreDigitale = ebook.distributoreDigitale;
              wbook.protezione = ebook.protezione;
              wbook.tipoContenuto1 = ebook.tipoContenuto1;

              wbook.bisac = _.cloneDeep(ebook.bisac);
              // console.log( ebook.bisac)
              // console.log( wbook.bisac)
              wbook.cce = ebook.cce;

              this.wmodel = _.cloneDeep(wbook);
              // console.log( this.wmodel )
            } else {
              this.wmodel = new Book(res.book);
            }

            this.coverpath = this.bookService.getBookCoverPath(ean13);
          }
          // console.log(res)
          this.parent.clearToast(wid);
          this.loading = false;
          this.parent.operSnackBar(res.success, res.success ? 'importazione completata' : res.err)
        })
      }, 1000);
    }))
  }

  onChooseCarpettaChange(e) {
    this.fcarpettaxls = e ? e.name : undefined;
    console.log(e)
  }

  bookFromGoogleSheet(ean13: string, worksheetTitle: string): void {
    this.uploadingGoogleSheet = true;
    this.parent.addToast('', 'importazione da Google Sheet in corso...', ((wid) => {
      setTimeout(() => {
        this.bookService.bookFromGoogleSheet(ean13, worksheetTitle)
          .subscribe(res => {
            console.log(res);
            if (res.success && res.book) {
              this.wmodel = new Book(res.book);
              this.coverpath = this.bookService.getBookCoverPath(res.book.ean13);
              this._crtlAutori(this.wmodel.contributor);
            }
            this.parent.clearToast(wid);
            this.uploadingGoogleSheet = false;
            // this.fcarpettaxls = undefined;
            // this.importFromCarpettaShown = false;
            this.parent.operSnackBar(res.success, res.success ? 'importazione completata' : res.err)
          },
          error => {
            console.log(error);
            this.parent.clearToast(wid);
            this.uploadingGoogleSheet = false;
            this.parent.operSnackBar(false, 'importazione fallita')
          })
      }, 1000);
    }))
  }

  bookFromGoogleSheetEvo(ean13: string, worksheetTitle: string): void {
    this.uploadingGoogleSheet = true;
    this.parent.addToast('', 'importazione da Google Sheet in corso...', ((wid) => {
      setTimeout(() => {
        this.bookService.bookFromGoogleSheetEvo(ean13, worksheetTitle)
          .subscribe(res => {
            console.log(res);
            if (res.success && res.book) {
              this.wmodel = new Book(res.book);
              this.coverpath = this.bookService.getBookCoverPath(res.book.ean13);
              this._crtlAutori(this.wmodel.contributor);
            }
            this.parent.clearToast(wid);
            this.uploadingGoogleSheet = false;
            this.parent.operSnackBar(res.success, res.success ? 'importazione completata' : res.err)
          },
          error => {
            console.log(error);
            this.parent.clearToast(wid);
            this.uploadingGoogleSheet = false;
            this.parent.operSnackBar(false, 'importazione fallita')
          })
      }, 1000);
    }))
  }

  uploadCarpetta(): void {
    let fi = this.fileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      let fileToUpload = fi.files[0];
      console.log(fileToUpload);
      this.fcarpettaxls = fileToUpload;

      this.uploadingCarpetta = true;
      this.parent.addToast('', 'importazione da carpetta in corso...', ((wid) => {
        setTimeout(() => {
          this.bookService.uploadCarpetta(fileToUpload)
            .subscribe(res => {
              console.log(res);
              if (res.success && res.book) {
                this.wmodel = new Book(res.book);
                this.coverpath = this.bookService.getBookCoverPath(res.book.ean13);
                this._crtlAutori(this.wmodel.contributor);
              }
              this.parent.clearToast(wid);
              this.uploadingCarpetta = false;
              this.fcarpettaxls = undefined;
              this.importFromCarpettaShown = false;
              this.parent.operSnackBar(res.success, res.success ? 'importazione completata' : res.err)
            },
            error => {
              console.log(error);
              this.parent.clearToast(wid);
              this.uploadingCarpetta = false;
              this.parent.operSnackBar(false, 'importazione fallita')
            })
        }, 1000);
      }))
    }
  }

  callSitoEndpoint(ean13: string) {
    setTimeout(() => {
      this.bookService.callSitoEndpointEvo(ean13)
        .subscribe(res => {
          this.parent.addPopupToast('', res.success ? 'sincronizzazione portale completata' : 'sincronizzazione portale fallita', 5000, res.success, null)
          console.log(res);
          // ===== AGGIORNAMENTO WEB SITE LINK =====
          if (res.success && res.book) {
            this.bookService.updateWebSiteLink(ean13, res.book.slug).subscribe((_res) => {
              if(_res.success) {
                console.log('updateWebSiteLink SUCCESS', _res.link);
                this.wmodel.websiteLink = _res.link;
              }
            }, (_e) => {
              console.log('updateWebSiteLink FAILED', _e);
            })
          }
        },
        error => {
          console.log(error);
          this.parent.addPopupToast('', 'sincronizzazione portale fallita', 5000, false, null)
        })
    }, 1000);
  }

  _init() {
    this.updateMode = false;
    const EDB = new Editore({ codice: '200084' })
    const LIBRO = new Onix({
      value: 'BA',
      label: 'Book',
      etichetta: 'Libro'
    })
    this.wmodel = new Book({
      editore: EDB,
      marchio: EDB,
      cityOfPublication: 'Bologna',
      tipoProdotto: LIBRO,
      // exportableCEC: true
    })

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      let ean13 = params['ean13'];
      if (ean13) {
        this.bookService.getBook(ean13).subscribe(result => {
          this.mongoBook = result.book;
          this.wmodel = this.bookService.fromMongo(this.mongoBook);
          console.log(this.route.snapshot.url[0]);
          console.log(this.wmodel);

          if (this.route.snapshot.url[0].path == 'clone-book') {
            this.wmodel.ean13 = null;
            this.updateMode = false;
          }
          else {
            this.updateMode = true;
          }
          // console.log(this.wmodel);

          console.log(this.wmodel.prezzo);
          if (!this.wmodel.prezzo) {
            //-20181024 servizio interrotto
            // this.bookService.getPrezzoFromEdiwinExport(ean13).subscribe(result => {
            //   console.log(result);
            //   if(result.success) {
            //     this.wmodel.prezzo = result.prezzo;
            //   }
            //   this.parent.operSnackBar(result.success, result.success ? 'prezzo preso da esportazione ediwin' : result.err)
            // })
          }
          if (!this.wmodel.tax) {
            this.wmodel.tax = new Onix({
              value: 'NS'
            })
          }





          this.coverpath = this.bookService.getBookCoverPath(ean13);
        })
      } else {
        this._init();
      }
    })

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      console.log("ImageUpload:uploaded:", item, status, response, this.coverpath);
      let wo = JSON.parse(response);
      console.log(wo);
      if (wo.success) {
        this.parent.operSnackBar(true, 'copertina caricata');
        this.coverpath = this.bookService.getBookCoverPath(this.wmodel.ean13);
      } else {
        let we = wo.err.code == 'LIMIT_FILE_SIZE' ? 'copertina troppo pesante (dimensione massima: 1 Mb)' : (wo.err.code == 'INVALID_FILE_TYPE' ? 'la copertina deve essere un jpeg' : wo.err);
        this.parent.operSnackBar(false, we);
      }
      this.uploader.queue = []
    }

    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      console.log('onBuildItemForm ean13: ', this.wmodel.ean13)
      form.append('ean13', this.wmodel.ean13);
    }
  }

  checkErrors(ff: FormGroup) {
    this.allErrors = [];
    if (ff) {
      if (!ff.valid) {
        for (var key in ff.controls) {
          ff.controls[key].markAsTouched({ onlySelf: true });
        }
        let ee = getFormValidationErrors(ff.controls);
        ee.forEach(e => {
          let text;
          switch (e.error_name) {
            case 'required': text = `${e.control_name}: campo obbligatorio`; break;
            case 'pattern': text = `${e.control_name}: formato errato`; break;
            case 'email': text = `${e.control_name}: formato errato`; break;
            //  case 'minlength': text = `${e.control_name} has wrong length! Required length: ${e.error_value.requiredLength}`; break;
            //  case 'areEqual': text = `${e.control_name} must be equal!`; break;
            // default: text = `${e.control_name}: ${e.error_name}: ${e.error_value}`;
            default: text = e.error_value.message;
          }
          this.allErrors.push({ control_name: e.control_name, message: text.toLowerCase().replace(/_/g, ' ') });
        })
      }
    }
  }

  isSectionWithError(s: string) {
    return this.allErrors ? this.allErrors.some(item => item.control_name.indexOf(s) != -1) : false;
  }

  ngAfterViewInit() {

  }

  // ===== CONTRIBUTORS ======
  addContributor() {
    this.wmodel.contributor.push(new Contributor())
  }

  removeContributor(i) {
    console.log('removeContributor index', i)
    this.wmodel.contributor.splice(i, 1);
    this._crtlAutori(this.wmodel.contributor);
  }

  trackContributor(index: number, value: Contributor) {
    return index;
  }

  // ===== RELATED PRODUCTS ======
  addRelatedProduct() {
    this.wmodel.relatedProducts.push(new ProductRelationship());
  }

  removeRelatedProduct(i) {
    console.log('removeRelatedProduct index', i)
    this.wmodel.relatedProducts.splice(i, 1);
  }

  trackRelatedProduct(index: number, value: ProductRelationship) {
    return index;
  }

  // ===== LINGUE ======
  addLingua() {
    this.wmodel.lingue.push(new Lingua());
  }

  removeLingua(i) {
    console.log('removeLingua index', i)
    this.wmodel.lingue.splice(i, 1);
  }

  trackLingua(index: number, value: Lingua) {
    return index;
  }

  // ===== Stagionalita ======
  addStagionalita() {
    this.wmodel.stagionalita.push(new Onix());
  }

  removeStagionalita(i) {
    console.log('removeStagionalita index', i)
    this.wmodel.stagionalita.splice(i, 1);
  }

  trackStagionalita(index: number, value: Onix) {
    return index;
  }

  // ===== Argomenti ======
  addArgomento() {
    this.wmodel.argomenti.push(new Argomento());
  }

  removeArgomento(i) {
    console.log('removeArgomento index', i)
    this.wmodel.argomenti.splice(i, 1);
  }

  trackArgomento(index: number, value: Argomento) {
    return index;
  }

  // ===== Bisac ======
  addBisac() {
    this.wmodel.bisac.push(new Bisac());
  }

  removeBisac(i) {
    console.log('removeBisac index', i)
    this.wmodel.bisac.splice(i, 1);
  }

  trackBisac(index: number, value: Bisac) {
    return index;
  }

  // ===== CCE ======
  addCce() {
    this.wmodel.cce.push(new Cce());
  }

  removeCce(i) {
    console.log('removeCce index', i)
    this.wmodel.cce.splice(i, 1);
  }

  trackCce(index: number, value: Cce) {
    return index;
  }

  // ===== Destinatari ======
  addDestinatario() {
    this.wmodel.destinatari.push(new Onix());
  }

  removeDestinatario(i) {
    console.log('removeDestinatario index', i)
    this.wmodel.destinatari.splice(i, 1);
  }

  trackDestinatario(index: number, value: Onix) {
    return index;
  }

  // ===== Catalogazione ======
  addCatalogazione() {
    this.wmodel.catalogazione.push(new Catalogazione());
  }

  removeCatalogazione(i) {
    console.log('removeCatalogazione index', i)
    this.wmodel.catalogazione.splice(i, 1);
  }

  trackCatalogazione(index: number, value: Catalogazione) {
    return index;
  }

  // ===== Servizio stampa ======
  addServizioStampa() {
    this.wmodel.servizioStampa.push(new ServizioStampa());
  }

  removeServizioStampa(i) {
    console.log('removeServizioStampa index', i)
    this.wmodel.servizioStampa.splice(i, 1);
  }

  trackServizioStampa(index: number, value: ServizioStampa) {
    return index;
  }


  // ===== DEWEY ======
  changeDeweyLevel01(e) {
    console.log('changeDeweyLevel01', e);
    this.ctrlDeweyDescrizione(e);
    this.wmodel.dewey_level2 = new Dewey({
      liv01: e.liv01
    })
    this.wmodel.dewey_level3 = new Dewey()
    this.wmodel.dewey_level4 = new Dewey()
  }

  changeDeweyLevel02(e) {
    console.log('changeDeweyLevel02', e);
    this.ctrlDeweyDescrizione(e);
    this.wmodel.dewey_level3 = new Dewey({
      liv01: e.liv01,
      liv02: e.liv02
    })
    this.wmodel.dewey_level4 = new Dewey()
  }

  changeDeweyLevel03(e) {
    console.log('changeDeweyLevel03', e);
    this.ctrlDeweyDescrizione(e);
    this.wmodel.dewey_level4 = new Dewey({
      liv01: e.liv01,
      liv02: e.liv02,
      liv03: e.liv03
    })
  }

  changeDeweyLevel04(e) {
    // console.log('changeDeweyLevel04', e);
    this.ctrlDeweyDescrizione(e);
  }

  ctrlDeweyDescrizione(e: Dewey) {
    console.log('!!! ctrlDeweyDescrizione', e);
    this.wmodel.dewey_descrizione = e.deweyDescrittore ?
      e.deweyCodice + ' (ed.' + e.deweyEdizione + ') ' + e.deweyDescrittore : null;
  }





  getTitle(): string {
    return "libro";
  }
}



// WEBPACK FOOTER //
// ./src/app/components/book/book-form/book-form.component.ts